<template>
    <div id="personal_monitor">
        <Operations></Operations>
        <div class="ui divider"></div>
        <CoreWaybills></CoreWaybills>
    </div>
</template>

<script>
import Operations from "../.components/global/operations/index.vue"
import CoreWaybills from "../.components/global/core_waybills/index.vue"

export default {
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    computed: {
    },
    methods: {
    },
    components: {
        Operations,
        CoreWaybills,
    }
}
</script>
<style scoped>
</style>
